<template>
  <v-form>
    <h3><slot name="header"></slot></h3>
    <v-content><slot name="content"></slot></v-content>
    <v-footer>=======just footer======</v-footer>
  </v-form>
</template>

<script>
export default {
  name: "basicform",
  mixins: [],
  created() {},
  data: () => ({}),
  components: {},
  props: {},
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style></style>
